import { render } from "./BlockedRecipientDetails.vue?vue&type=template&id=5cff85bc"
import script from "./BlockedRecipientDetails.vue?vue&type=script&lang=js"
export * from "./BlockedRecipientDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__